var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(15 13)",
    d: "M10 0L2 0C0.89531231 0 0 0.89531231 0 2L0 14C0 15.104688 0.89531231 16 2 16L10 16C11.104688 16 12 15.104688 12 14L12 2C12 0.89531231 11.103125 0 10 0ZM10.5 14C10.5 14.276125 10.276125 14.5 10 14.5L2 14.5C1.723875 14.5 1.5 14.276125 1.5 14L1.5 2C1.5 1.7238121 1.723875 1.5 2 1.5L4 1.5L4 2C4 2.552187 4.4478126 3 5 3L7 3C7.5521874 3 8 2.552187 8 2L8 1.5L10 1.5C10.276125 1.5 10.5 1.7238121 10.5 2L10.5 14ZM6 9C7.1046877 9 8 8.1046877 8 7C8 5.8953123 7.1046877 5 6 5C4.8968749 5 4 5.8968754 4 7C4 8.1031246 4.8968749 9 6 9ZM7 10L5 10C3.6193748 10 2.4999995 11.119375 2.4999995 12.5C2.4999995 12.775 2.7237496 13 2.9999995 13L9 13C9.276125 13 9.5 12.776125 9.5 12.5C9.5 11.11875 8.3812504 10 6.9999995 10L7 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.5e2f6ee3c9a5bd690bdec139526f24e4.svg";
export { ForwardRef as ReactComponent };